<template>
    <div class="float-left">
        <b-button
            variant="success"
            @click="abrirModal()"
            v-if="convenio.idSituacaoConvenio != 9"
            >Adicionar
        </b-button>
        <acao-form
            operacaoProp="I"
            :mostrarModal="mostrarModal"
            :erros="erros"
            @fechar="fecharModal()"
            @salvar="salvar($event)"
        ></acao-form>
    </div>
</template>

<script>
import ConveniosServicos from '../../ConveniosServicos'
import AcaoForm from './AcaoForm'

export default {
    components: {
        AcaoForm
    },

    props: {
        convenio: Object
    },

    data() {
        return {
            mostrarModal: false,
            erros: []
        }
    },

    methods: {
        abrirModal() {
            this.mostrarModal = true
        },

        fecharModal() {
            this.mostrarModal = false
        },

        salvar(descricao) {
            this.$store.dispatch('addRequest')
            let acao = {
                idConvenio: this.$route.params.convenioId,
                descricao: descricao
            }
            ConveniosServicos.inserirAcoes(acao).then((response) => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Ação inserida com sucesso',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.$emit('atualizarListaAcoes')
                        this.fecharModal()
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    }
}
</script>
